// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"0":"8660a611","528":"edde2c4a","581":"dedc837c","629":"6d42f99b"}[chunkId] + ".css";
};